// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NotFound_wrapper__3SY9G"};